// extracted by mini-css-extract-plugin
module.exports = {"circularImage":"styles_circularImage__sw9LS"};